import { FlatTeamSettingsSchema } from "@redotech/redo-model/flat-team-settings/index";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updatePickedSettings = unaryRpc({
  name: "updatePickedSettings",
  input: z.object({
    teamId: zExt.objectId(),
    settings: z.partialRecord(z.keyof(FlatTeamSettingsSchema), z.unknown()),
  }),
  output: z.object({ success: z.boolean() }),
});
